import {
    ACCOUNTS_CHANGE_STATUS_OPEN_MODAL,
    ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL,
    ACCOUNTS_CHANGE_STATUS_REQUEST,
    ACCOUNTS_CHANGE_STATUS_RESULT,
    ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST,
    ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT,
} from 'Redux/actionTypes';

export const accountsChangeStatusOpenModal = (data) => ({
    type: ACCOUNTS_CHANGE_STATUS_OPEN_MODAL,
    payload: data
})

export const accountsChangeStatusCloseModal = () => ({
    type: ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL
})

export const accountsChangeStatusRequest = (data) => ({
    type: ACCOUNTS_CHANGE_STATUS_REQUEST,
    payload: data
})

export const accountsChangeStatusResult = (result) => ({
    type: ACCOUNTS_CHANGE_STATUS_RESULT,
    payload: result
})

export const accountsChangeStatusScheduledRequest = (data) => ({
    type: ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST,
    payload: data
})

export const accountsChangeStatusScheduledResult = (data) => ({
    type: ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT,
    payload: data
})